import mapSliceTypeToComponent from '~/imports/universal_page'

import SliceManager from '~/components/SliceManager'

import { UNIVERSAL } from '~/data/fetch-links'
import {
  getStaticPathsFunction,
  getStaticPropsFunction,
} from '~/data/page-data'

function Universal({ slices }) {
  return (
    <SliceManager
      mapSliceTypeToComponent={mapSliceTypeToComponent}
      slicesData={slices}
    />
  )
}

export default Universal

export const getStaticProps = getStaticPropsFunction({
  type: 'universal_page',
  fetchLinks: UNIVERSAL,
})
export const getStaticPaths = getStaticPathsFunction({ type: 'universal_page' })
